import axios from 'axios'
import { api } from '../api'
import { createSelector } from 'reselect'
import bookingslist from '../mocks/bookings-list'
import bookingschecklist from '../mocks/bookings-checklist'

/**
 * Constants
 * */
export const moduleName = 'bookings'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const CLOSE = '_CLOSE'

export const BOOKINGS = `${moduleName}/BOOKINGS`
export const CHECKLIST = `${moduleName}/CHECKLIST`

export const RESET = `${moduleName}/RESET`

/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    success: null,
    cancel1: null,
    bookings: null,
    checklist: null,
}

export default (state = defaultState, action) => {
    const { type, error, response } = action

    switch (type) {
        case BOOKINGS + START:
            return { 
                ...state, 
                loading: true 
            }
        case BOOKINGS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                bookings: response
            }
        case BOOKINGS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
            }
        
        case CHECKLIST + START:
            return { 
                ...state, 
                loading: true 
            }
        case CHECKLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                checklist: response
            }
        case CHECKLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
            }
                        
        case RESET: 
            return defaultState

        default:
            return state
    }
}

/**
 * Action Creators
 * */

export const getBookingsList = (params) => async (dispatch) => {
    //return dispatch({ type: BOOKINGS + SUCCESS, response: bookingslist.content.BookingList })

    dispatch({ type: BOOKINGS + START })
    try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data);

        if (data.success) {
            dispatch({ 
                type: BOOKINGS + SUCCESS, 
                response: data.content.BookingList
            })
        }
        if (data.error) {
            dispatch({ 
                type: BOOKINGS + ERROR,
                error: data.message
            })
        }
    } catch (error) {
        console.log(error);
    }
}

/**
 * Selectors
 * */

export const selectBookings = (state) => state.bookings.bookings;
export const selectProjects = (state) => state.realty.projects;
export const selectTypes = (state) => state.realty.types;
export const selectManagers = (state) => state.meeting.managers;
export const selectBookingsList = createSelector(
    [
        selectBookings,
        selectProjects,
        selectTypes,
        selectManagers
    ],
    (bookings, projects, types, managers) => {
        if (bookings && projects && types && managers) {
            let expandedArray = bookings.map(item => {
                
                let project = projects.filter(obj => obj.id == item.projectId)
                let type = types.filter(obj => obj.id == item.typeId)
                
                return (
                    { 
                        ...item, 
                        //days: getDaysUntilEnd(item.dateEnd),
                        project: project ? project.name : '',  
                        type: type ? type.label : '',                         
                    }
                )
            });
            //console.log(expandedArray)
            return expandedArray
        }
    }
)

const getDaysUntilEnd = (endDate) => {
    if (!endDate) return '-';
    
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    
    const timeDiff = end.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

    if (daysDiff > 0) {
        return `${daysDiff} ${getDayWord(daysDiff)}`;
    } else if (daysDiff === 0) {
        return '0'; 
    } else {
        return '0'; 
    }
};

const getDayWord = (days) => {
    const lastDigit = days % 10;
    const lastTwoDigits = days % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return '';
    }
    if (lastDigit === 1) {
        return '';
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
        return '';
    }
    return '';
};


export const resetStore = () => async (dispatch) => dispatch({ type: RESET })